import { languages } from "./languages";

var Tennis = require("../img/sports/tennis.svg");
var Squash = require("../img/sports/squash.svg");
var Badminton = require("../img/sports/badminton.svg");
var TableTennis = require("../img/sports/table-tennis.svg");
var Volleyball = require("../img/sports/volleyball.svg");
var Football = require("../img/sports/football.svg");
var FieldHockey = require("../img/sports/field-hockey.svg");
var Basketball = require("../img/sports/basketball.svg");
var Handball = require("../img/sports/handball.svg");
var Korfball = require("../img/sports/korfball.svg");
var Darts = require("../img/sports/darts.svg");
var Judo = require("../img/sports/judo.svg");
var Curling = require("../img/sports/curling.svg");
var Petanque = require("../img/sports/petanque.svg");
var WaterPolo = require("../img/sports/water-polo.svg");
var AmericanFootball = require("../img/sports/american-football.svg");
var Baseball = require("../img/sports/baseball.svg");
var Rugby = require("../img/sports/rugby.svg");
var Hockey = require("../img/sports/ice-hockey.svg");
var Bowling = require("../img/sports/bowling.svg");
var Racquetball = require("../img/sports/racquetball.svg");
var Floorball = require("../img/sports/floorball.svg");
var Cricket = require("../img/sports/cricket.svg");
var Golf = require("../img/sports/golf.svg");
var Athletics = require("../img/sports/athletics.svg");
var Swimming = require("../img/sports/swimming.svg");
var Padel = require("../img/sports/padel.svg");
var WallBall = require("../img/sports/wallball.svg");
var InlineHockey = require("../img/sports/inline-hockey.svg");
var Takraw = require("../img/sports/takraw.svg");
var Fistball = require("../img/sports/fistball.svg");
var Netball = require("../img/sports/netball.svg");
var Futsal = require("../img/sports/futsal.svg");
var Pickleball = require("../img/sports/pickleball.svg");
var Rounders = require("../img/sports/rounders.svg");
var Billiard = require("../img/sports/billiard.svg");

var Esport = require("../img/sports/esport.svg");

var BoardGame = require("../img/sports/board-game.svg");
var CardGame = require("../img/sports/card-game.svg");
var Kubb = require("../img/sports/kubb.svg");
var BeerPong = require("../img/sports/beerpong.svg");
var Cornhole = require("../img/sports/cornhole.svg");
var Shuffleboard = require("../img/sports/shuffleboard.svg");
var MultiSport = require("../img/sports/multi-sports.svg");
var Other = require("../img/sports/trophy.svg");

export default [
  {
    id: 0,
    key: "tennis",
    name: languages.general.sports.tennis,
    sportType: "sport",
    icon: Tennis,
    iconFileName: "tennis.svg",
  },
  {
    id: 1,
    key: "squash",
    name: languages.general.sports.squash,
    sportType: "sport",
    icon: Squash,
    iconFileName: "squash.svg",
  },
  {
    id: 2,
    key: "badminton",
    name: languages.general.sports.badminton,
    sportType: "sport",
    icon: Badminton,
    iconFileName: "badminton.svg",
  },
  {
    id: 3,
    key: "table_tennis",
    name: languages.general.sports.tableTennis,
    sportType: "sport",
    icon: TableTennis,
    iconFileName: "table_tennis.svg",
  },
  {
    id: 4,
    key: "volleyball",
    name: languages.general.sports.volleyball,
    sportType: "sport",
    icon: Volleyball,
    iconFileName: "volleyball.svg",
  },
  {
    id: 5,
    key: "football",
    name: languages.general.sports.football,
    sportType: "sport",
    icon: Football,
    iconFileName: "football.svg",
  },
  {
    id: 69,
    key: "futsal",
    name: languages.general.sports.futsal,
    sportType: "sport",
    icon: Futsal,
    iconFileName: "futsal.svg",
  },
  {
    id: 6,
    key: "field_hockey",
    name: languages.general.sports.fieldHockey,
    sportType: "sport",
    icon: FieldHockey,
    iconFileName: "field_hockey.svg",
  },
  {
    id: 7,
    key: "basketball",
    name: languages.general.sports.basketball,
    sportType: "sport",
    icon: Basketball,
    iconFileName: "basketball.svg",
  },
  {
    id: 68,
    key: "netball",
    name: languages.general.sports.netball,
    sportType: "sport",
    icon: Netball,
    iconFileName: "netball.svg",
  },
  {
    id: 8,
    key: "handball",
    name: languages.general.sports.handball,
    sportType: "sport",
    icon: Handball,
    iconFileName: "handball.svg",
  },
  {
    id: 9,
    key: "korfball",
    name: languages.general.sports.korfball,
    sportType: "sport",
    icon: Korfball,
    iconFileName: "korfball.svg",
  },
  {
    id: 10,
    key: "darts",
    name: languages.general.sports.darts,
    sportType: "sport",
    icon: Darts,
    iconFileName: "darts.svg",
  },
  {
    id: 11,
    key: "judo",
    name: languages.general.sports.judo,
    sportType: "sport",
    icon: Judo,
    iconFileName: "judo.svg",
  },
  {
    id: 62,
    key: "wrestling",
    name: languages.general.sports.wrestling,
    sportType: "sport",
    icon: Judo,
    iconFileName: "judo.svg",
  },
  {
    id: 12,
    key: "curling",
    name: languages.general.sports.curling,
    sportType: "sport",
    icon: Curling,
    iconFileName: "curling.svg",
  },
  {
    id: 13,
    key: "petanque",
    name: languages.general.sports.petanque,
    sportType: "sport",
    icon: Petanque,
    iconFileName: "petanque.svg",
  },
  {
    id: 14,
    key: "water_polo",
    name: languages.general.sports.waterPolo,
    sportType: "sport",
    icon: WaterPolo,
    iconFileName: "water_polo.svg",
  },
  {
    id: 15,
    key: "american_football",
    name: languages.general.sports.americanFootball,
    sportType: "sport",
    icon: AmericanFootball,
    iconFileName: "american_football.svg",
  },
  {
    id: 61,
    key: "flag_football",
    name: languages.general.sports.flagFootball,
    sportType: "sport",
    icon: AmericanFootball,
    iconFileName: "american_football.svg",
  },
  {
    id: 16,
    key: "baseball",
    name: languages.general.sports.baseball,
    sportType: "sport",
    icon: Baseball,
    iconFileName: "baseball.svg",
  },
  {
    id: 17,
    key: "rugby",
    name: languages.general.sports.rugby,
    sportType: "sport",
    icon: Rugby,
    iconFileName: "rugby.svg",
  },
  {
    id: 18,
    key: "ice_hockey",
    name: languages.general.sports.hockey,
    sportType: "sport",
    icon: Hockey,
    iconFileName: "ice_hockey.svg",
  },
  {
    id: 19,
    key: "bowling",
    name: languages.general.sports.bowling,
    sportType: "sport",
    icon: Bowling,
    iconFileName: "bowling.svg",
  },
  {
    id: 20,
    key: "racquetball",
    name: languages.general.sports.racquetball,
    sportType: "sport",
    icon: Racquetball,
    iconFileName: "racquetball.svg",
  },
  {
    id: 70,
    key: "pickleball",
    name: languages.general.sports.pickleball,
    sportType: "sport",
    icon: Pickleball,
    iconFileName: "pickleball.svg",
  },
  {
    id: 21,
    key: "floorball",
    name: languages.general.sports.floorball,
    sportType: "sport",
    icon: Floorball,
    iconFileName: "floorball.svg",
  },
  {
    id: 22,
    key: "cricket",
    name: languages.general.sports.cricket,
    sportType: "sport",
    icon: Cricket,
    iconFileName: "cricket.svg",
  },
  {
    id: 23,
    key: "golf",
    name: languages.general.sports.golf,
    sportType: "sport",
    icon: Golf,
    iconFileName: "golf.svg",
  },
  {
    id: 24,
    key: "athletics",
    name: languages.general.sports.athletics,
    sportType: "sport",
    icon: Athletics,
    iconFileName: "athletics.svg",
  },
  {
    id: 25,
    key: "swimming",
    name: languages.general.sports.swimming,
    sportType: "sport",
    icon: Swimming,
    iconFileName: "swimming.svg",
  },
  {
    id: 26,
    key: "padel",
    name: languages.general.sports.padel,
    sportType: "sport",
    icon: Padel,
    iconFileName: "padel.svg",
  },
  {
    id: 53,
    key: "wallball",
    name: languages.general.sports.wallball,
    sportType: "sport",
    icon: WallBall,
    iconFileName: "wallball.svg",
  },
  {
    id: 55,
    key: "freestyle_football",
    name: languages.general.sports.freestyleFootball,
    sportType: "sport",
    icon: Football,
    iconFileName: "football.svg",
  },
  {
    id: 56,
    key: "walking_football",
    name: languages.general.sports.walkingFootball,
    sportType: "sport",
    icon: Football,
    iconFileName: "football.svg",
  },
  {
    id: 65,
    key: "beach_soccer",
    name: languages.general.sports.beachSoccer,
    sportType: "sport",
    icon: Football,
    iconFileName: "football.svg",
  },
  {
    id: 64,
    key: "beach_volleyball",
    name: languages.general.sports.beachVolleyball,
    sportType: "sport",
    icon: Volleyball,
    iconFileName: "volleyball.svg",
  },
  {
    id: 57,
    key: "beach_tennis",
    name: languages.general.sports.beachTennis,
    sportType: "sport",
    icon: Tennis,
    iconFileName: "tennis.svg",
  },
  {
    id: 59,
    key: "inline_hockey",
    name: languages.general.sports.inlineHockey,
    sportType: "sport",
    icon: InlineHockey,
    iconFileName: "inline_hockey.svg",
  },
  {
    id: 60,
    key: "takraw",
    name: languages.general.sports.takraw,
    sportType: "sport",
    icon: Takraw,
    iconFileName: "takraw.svg",
  },
  {
    id: 67,
    key: "fistball",
    name: languages.general.sports.fistball,
    sportType: "sport",
    icon: Fistball,
    iconFileName: "fistball.svg",
  },
  {
    id: 71,
    key: "rounders",
    name: languages.general.sports.rounders,
    sportType: "sport",
    icon: Rounders,
    iconFileName: "rounders.svg",
  },
  {
    id: 73,
    key: "billiard",
    name: languages.general.sports.billiard,
    sportType: "sport",
    icon: Billiard,
    iconFileName: "billiard.svg",
  },
  {
    id: 27,
    key: "league_of_legends",
    name: "League of Legends",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 28,
    key: "fifa",
    name: "FIFA",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 29,
    key: "pes",
    name: "PES",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 30,
    key: "rocket_league",
    name: "Rocket League",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 31,
    key: "nhl",
    name: "NHL",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 32,
    key: "dota2",
    name: "Dota2",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 33,
    key: "world_of_tanks",
    name: "World of Tanks",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 34,
    key: "rainbow_six_siege",
    name: "Rainbow Six Siege",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 35,
    key: "pubg",
    name: "PUBG",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 36,
    key: "fortnite",
    name: "Fortnite",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 37,
    key: "apex_legends",
    name: "Apex Legends",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 38,
    key: "call_of_duty_warzone",
    name: "Call of Duty: Warzone",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 39,
    key: "call_of_duty",
    name: "Call of Duty",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 40,
    key: "counter_strike",
    name: "Counter Strike",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 41,
    key: "valorant",
    name: "Valorant",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 42,
    key: "age_of_empires",
    name: "Age of Empires",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 43,
    key: "free_fire",
    name: "Free Fire",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 44,
    key: "mobile_legends",
    name: "Mobile Legends",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 45,
    key: "clash_royale",
    name: "Clash Royale",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 46,
    key: "brawl_stars",
    name: "Brawl Stars",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 47,
    key: "clash_of_clans",
    name: "Clash of Clans",
    sportType: "esport",
    icon: Esport,
    iconFileName: "esport.svg",
  },
  {
    id: 48,
    key: "board_game",
    name: languages.general.sports.boardGame,
    sportType: "other",
    icon: BoardGame,
    iconFileName: "board_game.svg",
  },
  {
    id: 49,
    key: "card_game",
    name: languages.general.sports.cardGame,
    sportType: "other",
    icon: CardGame,
    iconFileName: "card_game.svg",
  },
  {
    id: 54,
    key: "kubb",
    name: languages.general.sports.kubb,
    sportType: "other",
    icon: Kubb,
    iconFileName: "kubb.svg",
  },
  {
    id: 50,
    key: "beer_pong",
    name: languages.general.sports.beerPong,
    sportType: "other",
    icon: BeerPong,
    iconFileName: "beerpong.svg",
  },
  {
    id: 58,
    key: "cornhole",
    name: languages.general.sports.cornhole,
    sportType: "other",
    icon: Cornhole,
    iconFileName: "cornhole.svg",
  },
  {
    id: 63,
    key: "shuffleboard",
    name: languages.general.sports.shuffleboard,
    sportType: "other",
    icon: Shuffleboard,
    iconFileName: "shuffleboard.svg",
  },
  {
    id: 66,
    key: "showdown",
    name: languages.general.sports.showdown,
    sportType: "other",
    icon: WallBall,
    iconFileName: "wallball.svg",
  },
  {
    id: 72,
    key: "molkky",
    name: languages.general.sports.molkky,
    sportType: "other",
    icon: Other,
    iconFileName: "trophy.svg",
  },
  {
    id: 51,
    key: "multi_sport",
    name: languages.general.sports.multiSport,
    sportType: "other",
    icon: MultiSport,
    iconFileName: "multi_sports.svg",
  },
  {
    id: 52,
    key: "other",
    name: languages.general.sports.other,
    sportType: "other",
    icon: Other,
    iconFileName: "trophy.svg",
  },
];
